import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import { MdDragIndicator, MdEdit, MdDelete } from "react-icons/md";
import { SECTION_TYPE_LABELS, SectionType } from "consts/sectionTypes";
import { LayoutSectionConfig } from "./types";

interface LayoutSectionChipProps {
  section: LayoutSectionConfig;
  onEdit: () => void;
  onDelete: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
  isDragging?: boolean;
}

export const LayoutSectionChip = ({
  section,
  onEdit,
  onDelete,
  dragHandleProps,
  isDragging,
}: LayoutSectionChipProps) => {
  const label = SECTION_TYPE_LABELS[section.type as SectionType] ?? section.type;

  return (
    <div
      className={`flex items-center gap-2 rounded-md border bg-white px-2 py-1.5 text-sm dark:bg-slate-800 ${
        isDragging
          ? "border-indigo-400 shadow-lg dark:border-indigo-500"
          : "border-slate-200 dark:border-slate-700"
      }`}
    >
      <div {...dragHandleProps} className="cursor-grab text-slate-400 dark:text-slate-500">
        <MdDragIndicator size={16} />
      </div>
      <span className="flex-1 truncate font-medium text-slate-700 dark:text-slate-300">{label}</span>
      {section.name && (
        <span className="truncate text-xs text-slate-400 dark:text-slate-500">({section.name})</span>
      )}
      <button
        type="button"
        onClick={onEdit}
        className="rounded p-0.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-slate-700 dark:hover:text-slate-300"
      >
        <MdEdit size={14} />
      </button>
      <button
        type="button"
        onClick={onDelete}
        className="rounded p-0.5 text-slate-400 hover:bg-red-100 hover:text-red-600 dark:hover:bg-red-900/30 dark:hover:text-red-400"
      >
        <MdDelete size={14} />
      </button>
    </div>
  );
};
